import { render, staticRenderFns } from "./veStuAssocShow.vue?vue&type=template&id=08cb1fb6&scoped=true"
import script from "./veStuAssocShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb1fb6",
  null
  
)

export default component.exports